export * from "modules/AppointmentDetails/components/VehicleTyres/components/TyreTable/components/TyreReplacementTableRow/components/TyreActions";
